import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";

import * as api from "apis/shiftScheduleSwap";

//Query untuk get detail shift shcedule swap
export function useShiftScheduleSwap(payload = {}, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["shiftScheduleSwap", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getShiftScheduleSwap(payload?.id);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}
